import React from 'react';
import { layouts } from 'seal-ui-components';
import { useSelector } from 'react-redux';
import { Drawer } from '@Components/Drawer';
import { useHistory, useParams } from 'react-router-dom';
import { ClauseDetailsCard } from './components/ClauseDetailsCard';
import { decodeHtmlText } from '@Utils/commonUtils';
import store from '@Store';
import { CLAUSE_LIBRARY } from '@Constants/types';

const ClauseDetails = ({ className }) => {
    const { id } = useParams();
    const history = useHistory();

    const { flattenClauseGroups, isDrawerVisible } = useSelector(state => state.clause);

    const modalHeader =
        flattenClauseGroups[id].clauseCategoryTaxonomy || flattenClauseGroups[id].name;
    const { clauses } = flattenClauseGroups[id];

    const { text, description } = clauses[0] || {};
    const [subTitle, ...rest] = modalHeader.split('>').reverse();
    const title = rest.reverse().join('/');

    const handleCloseModal = () => {
        store.dispatch({ type: CLAUSE_LIBRARY.SET_DRAWER_OPEN_STATE, payload: false });
        setTimeout(() => {
            history.goBack();
            // history.replace('/clauses');
        }, 250);
    };

    return (
        <Drawer
            dir={'left'}
            isOpen={isDrawerVisible}
            close={handleCloseModal}
            className={`${className} clause-modal`}
        >
            <layouts.VerticalBox>
                <layouts.BoxText data-testid="primary_clause_title" style={{ opacity: '0.4' }}>
                    Primary Language
                </layouts.BoxText>
                <ClauseDetailsCard
                    title={title}
                    subTitle={subTitle}
                    text={decodeHtmlText(text)}
                    description={decodeHtmlText(description)}
                    key={clauses[0].id}
                    clauseId={clauses[0].id}
                    clausesCount={clauses.length}
                    clausePriority={clauses[0].priority}
                />

                {clauses.length > 1 && (
                    <>
                        <layouts.BoxText
                            data-testid="fallback_clause_title"
                            style={{ opacity: '0.4' }}
                        >
                            Fallback Language ({clauses.length - 1})
                        </layouts.BoxText>
                        {clauses.map(clause => {
                            if (clause.priority > 1) {
                                return (
                                    <ClauseDetailsCard
                                        title={title}
                                        subTitle={subTitle}
                                        clauseId={clause.id}
                                        key={clause.id}
                                        text={decodeHtmlText(clause.text)}
                                        description={decodeHtmlText(clause.description)}
                                        clausesCount={clauses.length}
                                        clausePriority={clause.priority}
                                    />
                                );
                            }
                            return null;
                        })}
                    </>
                )}
            </layouts.VerticalBox>
        </Drawer>
    );
};

export default ClauseDetails;
